import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { searchProducts } from '../../../crud/product.crud';
import { getResponseMessage } from '../../../utils/utils';
import { IProduct } from '../../../interfaces/product';
import { ICompany } from '../../../interfaces/companies';

export type TSearchItem = {
  id: number;
  name: string;
  product_type: string;
  item: IProduct | ICompany;
};

export const useSearchList = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingSearch, setLoading] = useState(false);
  const [productsSearch, setProducts] = useState<TSearchItem[] | null>(null);

  const fetchProducts = (
    text: string,
    manufacturer_ids?: string,
    price_from?: number,
    price_to?: number
  ) =>
    searchProducts(text, manufacturer_ids, price_from, price_to)
      .then(res => res.data.data)
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
        return [];
      });

  // const fetchCompanies = (text: string) =>
  //   getSearchCompanies(text, 'producer')
  //     .then(res => res.data.data)
  //     .catch(e => {
  //       enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
  //         variant: 'error',
  //       });
  //       return [];
  //     });

  const fetchSearch = useCallback(
    async (
      text: string,
      manufacturer_ids?: string,
      price_from?: number,
      price_to?: number
    ) => {
      setProducts(null);
      setLoading(true);
      const [products] = await Promise.all([
        fetchProducts(text, manufacturer_ids, price_from, price_to),
        // fetchCompanies(text),
      ]);

      const modifiedProducts = products?.products?.map((i: IProduct) => ({
        name: i.name,
        id: i.id,
        product_type: i.product_type?.special_type,
        item: i,
      }));
      const modifiedCategories = products?.categories?.map((i: ICompany) => ({
        name: i.name,
        id: i.id,
        product_type: 'category',
        item: i,
      }));

      setProducts([...modifiedProducts, ...modifiedCategories]);
      setLoading(false);
    },
    []
  );

  const clearSearch = () => {
    setProducts(null);
  };

  return { fetchSearch, loadingSearch, productsSearch, clearSearch };
};
